/** @flow */

import { combineReducers } from "redux";

import { reducer as reduxFormReducer } from "redux-form";
import { i18nState } from "redux-i18n";

import appReducer from "@modules/app/reducer";
import accountReducer from "@modules/account/reducer";
import clientsReducer from "@modules/client/reducer";
import contextReducer from "@modules/context/reducer";
import hierarchyReducer from "@modules/hierarchy/reducer";
import employeeReducer from "@modules/employee/reducer";
import profileReducer from "@modules/profile/reducer";
import reportingReducer from "@modules/reporting/reducer";
import serviceReducer from "@modules/service/reducer";
import dataReducer from "@modules/data/reducer";
import sharedReducer from "@modules/shared/reducer";
import settingsReducer from "@modules/settings/reducer";
import type { Action } from "@actionCreator";

export const reducers = {
  app: appReducer,
  account: accountReducer,
  clients: clientsReducer,
  context: contextReducer,
  hierarchy: hierarchyReducer,
  employees: employeeReducer,
  form: reduxFormReducer,
  profile: profileReducer,
  reporting: reportingReducer,
  service: serviceReducer,
  data: dataReducer,
  shared: sharedReducer,
  settings: settingsReducer,
  i18nState,
};

// State is a representation of the root state, based on the reducers.
// See https://flow.org/en/docs/types/utilities/#toc-objmap for more.
export type State = $ObjMap<typeof reducers, <T>((state: T, a: Action<*, *>) => T) => T>;

export default combineReducers(reducers);
